"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.regexp.replace");require("core-js/modules/es6.regexp.split");require("core-js/modules/es6.regexp.to-string");
































































































































































































var _user = require("@/utils/user");


var _formatter = require("@/utils/formatter"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { data: function data() {return { tableData: [], // 列表数据
      modelDroplist: [], checkList: [], musicArr: [{ name: '有', value: '1' }, { name: '无', value: '0' }], searchData: { deviceTypeId: '', time: '', page: 1, // 当前页码
        rows: 10 // 页码条数
      }, tableColumns: [{ prop: 'name', label: '产品型号', isShow: true }, { prop: 'ratedVoltage', label: '额定电压', isShow: true }, { prop: 'verticalSize', label: '尺寸(直立状态)', isShow: true }, { prop: 'backSize', label: '尺寸(倒背状态)', isShow: true }, { prop: 'grossWeight', label: '重量(毛重kg)', isShow: true }, { prop: 'netWeight', label: '重量(净重kg)', isShow: true }, { prop: 'envTemp', label: '使用环境(环境温度°C)', isShow: true }, { prop: 'relativeTemp', label: '使用环境(相对湿度%RH)', isShow: true }, { prop: 'safeFunc', label: '安全功能', isShow: true }, { prop: 'createTime', label: '配置时间', sortable: true, formatter: _formatter.dateFormatter, isShow: true }, { prop: 'operatorName', label: '配置人', isShow: true }, { prop: 'shelfStatus', label: '状态', formatter: _formatter.shelfStatusFormatter, isShow: true }, { prop: 'updateTime', label: '更新时间', sortable: true, formatter: _formatter.dateFormatter, isShow: false }], pageData: { page: 1, rows: 10, total: 0, pages: 1 }, newadd: false, title: '新增', addData: { id: '', deviceTypeId: '', ratedVoltage: '', verticalSize: '', backSize: '', envTemp: '', relativeTemp: '', verticalSizeArr: { long: '', width: '', hight: '' }, backSizeArr: { long: '', width: '', hight: '' }, grossWeight: '', netWeight: '', envTempArr: { start: '', end: '' }, relativeTempArr: { start: '', end: '' }, safeFunc: '', movement: '', character: '', detect: '', rail: '', autoProgram: '', heat: '', feetGo: '', blueMusic: '', balloonNum: '', shelfStatus: 0 }, defaultData: { id: '', deviceTypeId: '', ratedVoltage: '', verticalSize: '', backSize: '', envTemp: '', relativeTemp: '', verticalSizeArr: { long: '', width: '', hight: '' }, backSizeArr: { long: '', width: '', hight: '' }, grossWeight: '', netWeight: '', envTempArr: { start: '', end: '' }, relativeTempArr: { start: '', end: '' }, safeFunc: '', movement: '', character: '', detect: '', rail: '', autoProgram: '', heat: '', feetGo: '', blueMusic: '', balloonNum: '', shelfStatus: 0 }, rules: { deviceTypeId: [{ required: true, message: '请选择产品型号', trigger: 'change' }], ratedVoltage: [{ required: true, message: '请输入额定电压', trigger: 'blur' }], verticalSize: [{ required: true, message: '请输入直立尺寸', trigger: 'blur' }],

        backSize: [{
          required: true,
          message: '请输入倒背尺寸',
          trigger: 'blur' }],

        grossWeight: [{
          required: true,
          message: '请输入毛重',
          trigger: 'blur' }],

        netWeight: [{
          required: true,
          message: '请输入净重',
          trigger: 'blur' }],

        envTemp: [{
          required: true,
          message: '请输入环境温度',
          trigger: 'blur' }],

        relativeTemp: [{
          required: true,
          message: '请输入相对湿度',
          trigger: 'blur' }],

        safeFunc: [{
          required: true,
          message: '请输入安全功能',
          trigger: 'blur' }],

        movement: [{
          required: true,
          message: '请输入机芯',
          trigger: 'blur' }],

        character: [{
          required: true,
          message: '请输入特色',
          trigger: 'blur' }],

        detect: [{
          required: true,
          message: '请输入检测',
          trigger: 'blur' }],

        rail: [{
          required: true,
          message: '请输入导轨',
          trigger: 'blur' }],

        autoProgram: [{
          required: true,
          message: '请输入自动程序',
          trigger: 'blur' }],

        heat: [{
          required: true,
          message: '请选择加热部位',
          trigger: 'change' }],

        feetGo: [{
          required: true,
          message: '请输入脚滚',
          trigger: 'blur' }],

        blueMusic: [{
          required: true,
          message: '请选择蓝牙音乐',
          trigger: 'change' }],

        balloonNum: [{
          required: true,
          message: '请输入气囊数量',
          trigger: 'blur' }] } };



  },
  mounted: function mounted() {
    var self = this;
    self.init();
    self.getModelDroplist();
    //			self.getdrop()
  },
  methods: {
    checkPermission: _user.checkPermission,
    init: function init() {
      var self = this;
      var params = Object.assign({}, self.searchData);
      if (params.time) {
        params.startTime = params.time[0] + ' 00:00:00';
        params.endTime = params.time[1] + ' 23:59:59';
      }
      delete params['time'];
      self.getData('/api/deviceConfig', params, function (res) {
        self.tableData = res.list;
        self.pageData.page = res.pageNum;
        self.pageData.total = res.total;
      });
    },
    resetFun: function resetFun() {// 重置
      this.searchData.deviceTypeId = '';
      this.searchData.time = '';
      this.searchData.page = 1;
      this.init();
    },
    searchFun: function searchFun() {// 搜索事件
      this.searchData.page = 1;
      this.init();
    },

    handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;
      this.searchData.page = 1;
      this.init();
    },
    handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;
      this.init();
    },
    getModelDroplist: function getModelDroplist() {
      var self = this;
      self.getData('/api/faDeviceType/getDownList', {}, function (res) {
        self.modelDroplist = res;
      });
    },
    delMenu: function delMenu(item) {
      var self = this;
      self.$confirm('确定删除该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        self.delData('/api/deviceConfig', {
          id: item.id },
        function (res) {
          self.$message({
            message: '删除成功!',
            type: 'success' });

          self.searchData.page = 1;
          self.init();
        });
      }).catch(function () {});
    },
    addFun: function addFun() {// 新增
      this.title = '新增';
      this.addData = JSON.parse(JSON.stringify(this.defaultData));
      this.newadd = true;
    },
    closeRefund: function closeRefund(done) {// 重置新增列表
      this.$refs.addForm.resetFields();
      // this.$refs['addForm'].resetFields()
      this.checkList = [];
      done();
    },
    handleCheckedCitiesChange: function handleCheckedCitiesChange(value) {
      console.log('this.checkList:', this.checkList);
      this.addData.heat = this.checkList.toString();
    },
    onSubmit: function onSubmit() {
      var self = this;
      if (this.addData.verticalSizeArr.long == '' || this.addData.verticalSizeArr.long == null || this.addData.verticalSizeArr.long == undefined || this.addData.verticalSizeArr.width == '' || this.addData.verticalSizeArr.width == null || this.addData.verticalSizeArr.width == undefined || this.addData.verticalSizeArr.hight == '' || this.addData.verticalSizeArr.hight == null || this.addData.verticalSizeArr.hight == undefined) {
        self.$message({
          message: '直立状态数据填写不完整，请填写完整后再提交',
          type: 'warning' });

        return false;
      }
      if (this.addData.backSizeArr.long == '' || this.addData.backSizeArr.long == null || this.addData.backSizeArr.long == undefined || this.addData.backSizeArr.width == '' || this.addData.backSizeArr.width == null || this.addData.backSizeArr.width == undefined || this.addData.backSizeArr.hight == '' || this.addData.backSizeArr.hight == null || this.addData.backSizeArr.hight == undefined) {
        self.$message({
          message: '倒背状态数据填写不完整，请填写完整后再提交',
          type: 'warning' });

        return false;
      }
      if (this.addData.envTempArr.start == '' || this.addData.envTempArr.start == null || this.addData.envTempArr.start == undefined || this.addData.envTempArr.end == '' || this.addData.envTempArr.end == null || this.addData.envTempArr.end == undefined) {
        self.$message({
          message: '环境温度数据填写不完整，请填写完整后再提交',
          type: 'warning' });

        return false;
      }
      if (this.addData.relativeTempArr.start == '' || this.addData.relativeTempArr.start == null || this.addData.relativeTempArr.start == undefined || this.addData.relativeTempArr.end == '' || this.addData.relativeTempArr.end == null || this.addData.relativeTempArr.end == undefined) {
        self.$message({
          message: '相对湿度数据填写不完整，请填写完整后再提交',
          type: 'warning' });

        return false;
      }
      this.addData.verticalSize = this.addData.verticalSizeArr.long + '*' + this.addData.verticalSizeArr.width + '*' + this.addData.verticalSizeArr.hight;
      this.addData.backSize = this.addData.backSizeArr.long + '*' + this.addData.backSizeArr.width + '*' + this.addData.backSizeArr.hight;
      this.addData.envTemp = this.addData.envTempArr.start + '~' + this.addData.envTempArr.end;
      this.addData.relativeTemp = this.addData.relativeTempArr.start + '~' + this.addData.relativeTempArr.end;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          self.postData('/api/deviceConfig', self.addData, function (res) {
            self.$message({
              message: '添加成功!',
              type: 'success' });

            self.onCencal();
            self.searchData.page = 1;
            self.init();
          });
        } else {
          return false;
        }
      });
    },
    updateMenu: function updateMenu(item) {
      console.log(item);
      this.title = '修改';
      // 深度拷贝
      // this.addData = Object.assign({},item)
      this.addData.id = item.id,
      this.addData.deviceTypeId = item.deviceTypeId,
      this.addData.ratedVoltage = item.ratedVoltage,
      this.addData.verticalSize = item.verticalSize,
      this.addData.backSize = item.backSize,
      this.addData.grossWeight = item.grossWeight,
      this.addData.netWeight = item.netWeight,
      this.addData.envTemp = item.envTemp,
      this.addData.relativeTemp = item.relativeTemp,
      this.addData.safeFunc = item.safeFunc,
      this.addData.movement = item.movement,
      this.addData.character = item.character,
      this.addData.detect = item.detect,
      this.addData.rail = item.rail,
      this.addData.autoProgram = item.autoProgram,
      this.addData.heat = item.heat,
      this.addData.feetGo = item.feetGo,
      this.addData.blueMusic = item.blueMusic,
      this.addData.balloonNum = item.balloonNum,
      this.addData.shelfStatus = item.shelfStatus;
      this.checkList = item.heat.split(',');
      var verticalSizeArr = this.addData.verticalSize.split('*');
      this.addData.verticalSizeArr = {
        long: verticalSizeArr[0],
        width: verticalSizeArr[1],
        hight: verticalSizeArr[2] };

      var backSizeArr = item.backSize.split('*');
      this.addData.backSizeArr = {
        long: backSizeArr[0],
        width: backSizeArr[1],
        hight: backSizeArr[2] };

      var envTempArr = item.envTemp.split('~');
      this.addData.envTempArr = {
        start: envTempArr[0],
        end: envTempArr[1] };

      var relativeTempArr = item.relativeTemp.split('~');
      this.addData.relativeTempArr = {
        start: relativeTempArr[0],
        end: relativeTempArr[1] };

      this.newadd = true;
    },
    onUpdate: function onUpdate() {
      var self = this;
      if (this.addData.verticalSizeArr.long == '' || this.addData.verticalSizeArr.long == null || this.addData.verticalSizeArr.long == undefined || this.addData.verticalSizeArr.width == '' || this.addData.verticalSizeArr.width == null || this.addData.verticalSizeArr.width == undefined || this.addData.verticalSizeArr.hight == '' || this.addData.verticalSizeArr.hight == null || this.addData.verticalSizeArr.hight == undefined) {
        self.$message({
          message: '直立状态数据填写不完整，请填写完整后再提交',
          type: 'warning' });

        return false;
      }
      if (this.addData.backSizeArr.long == '' || this.addData.backSizeArr.long == null || this.addData.backSizeArr.long == undefined || this.addData.backSizeArr.width == '' || this.addData.backSizeArr.width == null || this.addData.backSizeArr.width == undefined || this.addData.backSizeArr.hight == '' || this.addData.backSizeArr.hight == null || this.addData.backSizeArr.hight == undefined) {
        self.$message({
          message: '倒背状态数据填写不完整，请填写完整后再提交',
          type: 'warning' });

        return false;
      }
      if (this.addData.envTempArr.start == '' || this.addData.envTempArr.start == null || this.addData.envTempArr.start == undefined || this.addData.envTempArr.end == '' || this.addData.envTempArr.end == null || this.addData.envTempArr.end == undefined) {
        self.$message({
          message: '环境温度数据填写不完整，请填写完整后再提交',
          type: 'warning' });

        return false;
      }
      if (this.addData.relativeTempArr.start == '' || this.addData.relativeTempArr.start == null || this.addData.relativeTempArr.start == undefined || this.addData.relativeTempArr.end == '' || this.addData.relativeTempArr.end == null || this.addData.relativeTempArr.end == undefined) {
        self.$message({
          message: '相对湿度数据填写不完整，请填写完整后再提交',
          type: 'warning' });

        return false;
      }
      this.addData.verticalSize = this.addData.verticalSizeArr.long + '*' + this.addData.verticalSizeArr.width + '*' + this.addData.verticalSizeArr.hight;
      this.addData.backSize = this.addData.backSizeArr.long + '*' + this.addData.backSizeArr.width + '*' + this.addData.backSizeArr.hight;
      this.addData.envTemp = this.addData.envTempArr.start + '~' + this.addData.envTempArr.end;
      this.addData.relativeTemp = this.addData.relativeTempArr.start + '~' + this.addData.relativeTempArr.end;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          self.putData('/api/deviceConfig', self.addData, function (res) {
            self.$message({
              message: '修改成功!',
              type: 'success' });

            self.searchData.page = 1;
            self.init();
            self.onCencal();
          });
        } else {
          return false;
        }
      });
    },
    onCencal: function onCencal() {
      this.newadd = false;
      this.$refs['addForm'].resetFields();
      this.checkList = [];
    },
    putStatusFun: function putStatusFun(item) {
      var self = this;
      var status = '';
      if (item.shelfStatus == '0') {
        status = '1';
      } else if (item.shelfStatus == '1') {
        status = '0';
      }
      self.putData('/api/deviceConfig/updateShelfStatus', {
        id: item.id,
        shelfStatus: status },
      function (res) {
        self.$message({
          message: '操作成功!',
          type: 'success' });

        self.init();
      });
    },
    changeKeyUp: function changeKeyUp(e, item) {
      if (item != null && item != undefined) {
        //先把非数字的都替换掉，除了数字和.
        item = item.replace(/[^\d.]/g, "");
        //必须保证第一个为数字而不是.
        item = item.replace(/^\./g, "");
        //保证只有出现一个.而没有多个.
        item = item.replace(/\.{2,}/g, "");
        //保证.只出现一次，而不能出现两次以上
        item = item.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
        item = item.replace();
        //最多保留小数点后一位
        var arr = item.split(".");
        if (arr.length > 1) item = arr[0] + '.' + (arr[1].length > 1 ? arr[1].substr(0, 1) : arr[1]);
      }
      if (e == 'envTempArr.start') {
        this.addData.envTempArr.start = item;
      } else if (e == 'envTempArr.end') {
        this.addData.envTempArr.end = item;
      } else if (e == 'relativeTempArr.start') {
        this.addData.relativeTempArr.start = item;
      } else if (e == 'relativeTempArr.end') {
        this.addData.relativeTempArr.end = item;
      } else if (e == 'grossWeight') {
        this.addData.grossWeight = item;
      } else if (e == 'netWeight') {
        this.addData.netWeight = item;
      }
    } } };exports.default = _default;